module.exports = __webpack_public_path__ + "img/Norway.4242037c.png";